import type { Component } from 'vue';

const load = () => import('./ui/index.vue');

export const ContactsModal: Component = defineAsyncComponent(() =>
  load().then((m: { default: Component }) => m.default),
);

export const prefetchContactsModal = (): void => {
  load().catch(() => null);
};
